import React from 'react';
import styled from 'styled-components';
import {fontSize, tabletWidth} from '../../mixins';
import QRCodeComp from '../../UI/QRCodeComp';
import {setNote} from '../note/noteSlice';
import {useDispatch, useSelector} from 'react-redux';
import {selectRegistrationSource} from '../auth/authSlice';
import {isMobile} from 'react-device-detect';
const appleLink = process.env.REACT_APP_DEEP_LINK_APPLE;

const StyledWrapper = styled.div`
  padding: 0 18px;
  
  @media screen and (max-width: ${tabletWidth}) {
   padding: 0;
  }
`;

const StyledTitle = styled.p`
  ${fontSize(34)};
  line-height: 40px;
  font-weight: 800;
  color: #323232;
  mix-blend-mode: normal;
  margin: 16px 0;
`;

const StyledQR = styled.div`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px auto;
`;

const StyledText = styled.p`
  ${fontSize(14)};
  line-height: 20px;
  color: #323232;
  mix-blend-mode: normal;
  text-align: center;
  
  b {
   color: #00BFA5;
  }
`;

const StyledGreyBox = styled.div`
  background-color: #F4F4F4;
  border-radius: 20px;
  padding: 4px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledBtn = styled.button`
  background-color: transparent;
  border: none;
  ${fontSize(16)};
  line-height: 21px;
  letter-spacing: -0.0376471px;
  color: #00BFA5;
  cursor: pointer;
`;

const StyledButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  
  a {
    width: 48%;
    
    img {
     width: auto;
     height: 47px;
    }
  }
`;


const DownloadApp = () => {
    const dispatch = useDispatch();
    const registrationSource = useSelector(selectRegistrationSource);

    const getMethodName = () => {
        if (registrationSource === 'google') return 'Google';
        if (registrationSource === 'facebook') return 'Facebook';
        if (registrationSource === 'email') return 'Email';
    };


    const onCopyLinkClick = () => {
        dispatch(setNote({show: true, text: 'Link copied'}));

        return navigator.clipboard.writeText(appleLink);
    };

    const mobileUI = (
        <StyledButtons>
            <a href={appleLink}><img src='../images/appstore.png' alt='apple'/></a>
            <a href={appleLink}><img src='../images/google.png' alt='google'/></a>
        </StyledButtons>
    );

    return (
        <StyledWrapper>
            <StyledTitle>You can do more with Geozilla on your phone!</StyledTitle>

            {isMobile ? mobileUI : <>
                <StyledQR>
                    <QRCodeComp link={appleLink} size={140}/>
                </StyledQR>
                <StyledText>or use this link on you phone: </StyledText>
                <StyledGreyBox>
                    <StyledText>{appleLink}</StyledText>
                    <StyledBtn onClick={onCopyLinkClick} id='continue-button'>Copy</StyledBtn>
                </StyledGreyBox>
            </>}
            <StyledText><b>Note:</b> {`Please choose ${getMethodName()} to log in to the app`}</StyledText>
        </StyledWrapper>
    );
};

export default DownloadApp;